import React from "react";

const Punished = () => {
  return (
    <div>
      <h2>Punished</h2>
      <h2>Punished</h2>
      <h2>Punished</h2>
    </div>
  );
};

export default Punished;
